<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1>Editar Regimento Interno</h1>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Título:">
                <b-input-group class="mb-3">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Título"
                                autocomplete="titulo"
                                v-model="$v.form.titulo.$model"
                                :state="chkState('titulo')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Descrição:" :state="chkState('descricao')">
                <wysiwyg v-model="form.descricao" :state="chkState('descricao')"/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <b-button variant="primary" v-on:click="adicionarArtigo()">
                Adicionar Artigo
              </b-button>
            </b-col>
          </b-row>
          <b-row v-for="(artigo, index) in form.artigos" :key="artigo.id" style="margin-top: 10px">
            <b-col cols="12">
              <b-row>
                <b-col cols="10"></b-col>
                <b-col cols="2">
                  <b-button variant="danger" v-on:click="removerArtigo(index)" style="float: right; margin-left: 10px;">
                    <i class="fa fa-minus"></i>
                  </b-button>
                  <b-button variant="info" v-on:click="adicionarArtigo()" style="float: right;">
                    <i class="fa fa-plus"></i>
                  </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <wysiwyg v-model="artigo.texto"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" md="3">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>Alterar Regimento</span>
            </b-button>
          </b-col>
          <b-col v-else md="3">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/regimento')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      }
    }
  },
  created () {
    if (!this.can('regimento.update')) {
      this.$router.push('/')
    }
    this.loadRegimento(this.$route.params.id)
  },
  data () {
    return {
      loading: false,
      form: {
        titulo: '',
        descricao: '',
        artigos: []
      },
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    loadRegimento (id) {
      Vue.http.get('api/regimento/' + id).then(response => {
        let data = response.body.data
        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        this.form.artigos = data.artigos
      })
    },
    adicionarArtigo () {
      this.form.artigos.push({
        id: null,
        texto: ''
      })
    },
    removerArtigo (key) {
      this.form.artigos.splice(key, 1)
    },
    salvar () {
      let form = this.$v.form
      let data = {
        titulo: form.titulo.$model,
        descricao: form.descricao.$model,
        artigos: this.form.artigos
      }
      this.loading = true

      Vue.http.put('api/regimento/' + this.$route.params.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/regimento'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/regimento/RegimentoEditar.vue